import { useLayoutEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CONTACT } from "../../data/content";

export const Layout = () => {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col bg-paper text-ink">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <a
        href={CONTACT.hotlineHref}
        data-testid="mobile-sticky-call-btn"
        className="sm:hidden fixed bottom-4 right-4 z-40 h-14 px-5 rounded-full bg-[#E3B321] text-ink font-semibold flex items-center gap-2 shadow-xl"
      >
        <Phone size={18} /> Appeler
      </a>
    </div>
  );
};
